import { createActions } from 'redux-actions'

export const {
  signInRequest,
  signInSucceed,
  logoutRequest,
  requestFailure,
  resetLoggingIn
} = createActions(
  {
    SIGN_IN_REQUEST: undefined,
    SIGN_IN_SUCCEED: undefined,
    LOGOUT_REQUEST: (delayMs) => delayMs,
    REQUEST_FAILURE: (err) => err,
    RESET_LOGGING_IN: undefined
  },
  { prefix: 'AUTH' }
)
